module.exports = __webpack_public_path__ + "img/4.06.thmb.xs.83b620e9.jpg";